import {
  Box,
  Button,
  HStack,
  VStack,
  Text,
  Select,
  Input,
  Collapse,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import DatePicker from "react-datepicker";
import { ru } from "date-fns/locale";
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  subMonths,
  subYears,
} from "date-fns";
import ColumnManager from "../column_manager";
import { INN_COLUMN_KEY } from "../../utils/report_columns";


const DateFilters = observer(() => {
  const { pageStore } = useStores();

  const getPeriodDates = (periodType) => {
    const now = new Date();
    switch (periodType) {
      case 'week':
        return {
          start: startOfWeek(now, { locale: ru }),
          end: endOfWeek(now, { locale: ru })
        };
      case 'month':
        return {
          start: startOfMonth(now),
          end: endOfMonth(now)
        };
      case 'pastMonth': {
        const lastMonth = subMonths(now, 1);
        return {
          start: startOfMonth(lastMonth),
          end: endOfMonth(lastMonth)
        };
      }
      case 'quarter':
        return {
          start: startOfQuarter(now),
          end: endOfQuarter(now)
        };
      case 'halfYear':
        return {
          start: startOfMonth(subMonths(now, 6)),
          end: endOfMonth(now)
        };
      case 'year':
        return {
          start: startOfYear(now),
          end: endOfYear(now)
        };
      case 'pastYear':
        const lastYear = subYears(now, 1);
        return {
          start: startOfYear(lastYear),
          end: endOfYear(lastYear)
        };
      default:
        return { start: null, end: null };
    }
  };

  const handleStartPeriodChange = (periodType) => {
    if (periodType === 'none') {
      pageStore.setOrderStartOpenDateFilter(null);
      pageStore.setOrderEndOpenDateFilter(null);
    } else if (periodType !== 'custom') {
      const dates = getPeriodDates(periodType);
      pageStore.setOrderStartOpenDateFilter(dates.start);
      pageStore.setOrderEndOpenDateFilter(dates.end);
    }
  };

  const handleEndPeriodChange = (periodType) => {
    if (periodType === 'none') {
      pageStore.setOrderStartCloseDateFilter(null);
      pageStore.setOrderEndCloseDateFilter(null);
    } else if (periodType !== 'custom') {
      const dates = getPeriodDates(periodType);
      pageStore.setOrderStartCloseDateFilter(dates.start);
      pageStore.setOrderEndCloseDateFilter(dates.end);
    }
  };

  return (
    <>
      <Collapse in={pageStore.open_filter} animateOpacity style={{ overflow: pageStore.open_filter ? 'visible' : 'hidden' }}>
        <HStack textColor={"white"} width={"100%"} justifyItems={"center"} align={"start"} gap={"20px"} mb={4} flexWrap="wrap">
          <ColumnManager
            report="potential"
            columns={pageStore.columnConfigPotential}
            onChange={(newColumns) => pageStore.setColumnConfigPotential(newColumns)}
            introducedColumnKeys={[INN_COLUMN_KEY]}
          />
          <VStack>
            <Text fontSize={"20px"}>ID сделки</Text>
            <Input
              value={pageStore.order_deal_filter}
              onChange={(e) => pageStore.setOrderDealFilter(e.target.value)}
              width={"10vw"}
            />
          </VStack>
          <VStack>
            <Text fontSize={"20px"}>Номер счёта</Text>
            <Input
              value={pageStore.order_num_filter}
              onChange={(e) => pageStore.setOrderNumFilter(e.target.value)}
              width={"10vw"}
            />
          </VStack>
          <VStack>
            <Text fontSize={"20px"}>Период открытия счёта</Text>
            {/* Фильтр по дате открытия */}
            <Select
              value={pageStore.order_type_date_start_filter}
              onChange={(e) => {
                pageStore.setOrderTypeDateStartFilter(e.target.value);
                handleStartPeriodChange(e.target.value);
              }}
              width={"15vw"}
            >
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="none">Без фильтра(все)</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="fill">Открыт</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="week">Текущая неделя</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="month">Текущий месяц</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="pastMonth">Прошлый месяц</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="quarter">Текущий квартал</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="halfYear">Текущее полугодие</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="year">Текущий год</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="pastYear">Прошлый год</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="custom">Произвольный период</option>
            </Select>


          </VStack>
          {/* Фильтр по дате закрытия */}
          <VStack>
            <Text fontSize={"20px"}>Период закрытия счёта</Text>
            <Select
              value={pageStore.order_type_date_end_filter}
              onChange={(e) => {
                pageStore.setOrderTypeDateEndFilter(e.target.value);
                handleEndPeriodChange(e.target.value);
              }}
              width={"15vw"}
            >
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="none">Без фильтра(все)</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="fill">Закрыт</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="empty">Не закрыт</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="week">Текущая неделя</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="month">Текущий месяц</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="pastMonth">Прошлый месяц</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="quarter">Текущий квартал</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="halfYear">Текущее полугодие</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="year">Текущий год</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="pastYear">Прошлый год</option>
              <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="custom">Произвольный период</option>
            </Select>


          </VStack>
          {pageStore.order_type_date_start_filter === 'custom' && (
            <VStack>
              <Text fontSize={"20px"}>Дата открытия счёта</Text>
              <HStack>
                <DatePicker
                  selected={pageStore.order_start_open_date_filter ? new Date(pageStore.order_start_open_date_filter) : ''}
                  onChange={(date) => pageStore.setOrderStartOpenDateFilter(date)}
                  width={"15vw"}
                  dateFormat="dd.MM.yyyy"
                  locale={ru}
                  placeholderText="выберете день начала"
                  popperContainer={({ children }) => (
                    <div style={{ zIndex: 9999, position: 'relative' }}>{children}</div>
                  )}
                  customInput={
                    <Input
                      style={{
                        border: "none",
                        background: "#333",
                        color: "#EEEEEE",
                        borderRadius: "10px",
                        fontWeight: 600,
                      }}
                    />
                  }
                />

                <DatePicker
                  selected={pageStore.order_end_open_date_filter ? new Date(pageStore.order_end_open_date_filter) : ''}
                  onChange={(date) => pageStore.setOrderEndOpenDateFilter(date)}
                  width={"15vw"}
                  dateFormat="dd.MM.yyyy"
                  locale={ru}
                  placeholderText="выберете день окончания"
                  popperContainer={({ children }) => (
                    <div style={{ zIndex: 9999, position: 'relative' }}>{children}</div>
                  )}
                  customInput={
                    <Input
                      style={{
                        border: "none",
                        background: "#333",
                        color: "#EEEEEE",
                        borderRadius: "10px",
                        fontWeight: 600,
                      }}
                    />
                  }
                />
              </HStack>
            </VStack>
          )}
          {pageStore.order_type_date_end_filter === 'custom' && (
            <VStack>
              <Text fontSize={"20px"}>Дата закрытия счёта</Text>
              <HStack>
                <DatePicker
                  selected={
                    pageStore.order_start_close_date_filter
                      ? new Date(pageStore.order_start_close_date_filter)
                      : ''
                  }
                  onChange={(date) => pageStore.setOrderStartCloseDateFilter(date)}
                  width={"15vw"}
                  dateFormat="dd.MM.yyyy"
                  locale={ru}
                  placeholderText="выберете день начала"
                  popperContainer={({ children }) => (
                    <div style={{ zIndex: 9999, position: 'relative' }}>{children}</div>
                  )}
                  customInput={
                    <Input
                      style={{
                        border: "none",
                        background: "#333",
                        color: "#EEEEEE",
                        borderRadius: "10px",
                        fontWeight: 600,
                      }}
                    />
                  }
                />

                <DatePicker
                  selected={
                    pageStore.order_end_close_date_filter
                      ? new Date(pageStore.order_end_close_date_filter)
                      : ''
                  }
                  onChange={(date) => pageStore.setOrderEndCloseDateFilter(date)}
                  width={"15vw"}
                  dateFormat="dd.MM.yyyy"
                  locale={ru}
                  placeholderText="выберете день окончания"
                  popperContainer={({ children }) => (
                    <div style={{ zIndex: 9999, position: 'relative' }}>{children}</div>
                  )}
                  customInput={
                    <Input
                      style={{
                        border: "none",
                        background: "#333",
                        color: "#EEEEEE",
                        borderRadius: "10px",
                        fontWeight: 600,
                      }}
                    />
                  }
                />
              </HStack>
            </VStack>
          )}
        </HStack>
      </Collapse>
      <HStack
        justify="space-between"
        mb={4}
        borderBottom="1px solid #444"
        pb={3}
        w="full"
      >
        <Button
          size="sm"
          bg="#333"
          color="white"
          onClick={() => pageStore.setOpenFilters(!pageStore.open_filter)}
          _hover={{ bg: "#444" }}
          leftIcon={pageStore.open_filter ? <span>−</span> : <span>+</span>}
        >
          {pageStore.open_filter ? "Скрыть фильтры" : "Открыть фильтры"}
        </Button>
        <HStack spacing={4} flex="1">
          <Text fontSize="12px" fontWeight="bold" color="gray.400" whiteSpace="nowrap">
            Высота строк: {pageStore.rowHeight}
          </Text>

          <HStack spacing={2} flex="1" maxW="300px">
            <Button
              size="xs"
              onClick={() => pageStore.setRowHeight(Math.max(0, pageStore.rowHeight - 1))}
            >
              -
            </Button>

            <Slider
              id="row-padding-slider"
              min={0}
              max={10}
              step={1}
              value={pageStore.rowHeight}
              onChange={(v) => pageStore.setRowHeight(v)}
              colorScheme="green"
            >
              <SliderTrack bg="#444">
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb boxSize={3} />
            </Slider>

            <Button
              size="xs"
              onClick={() => pageStore.setRowHeight(Math.min(10, pageStore.rowHeight + 1))}
            >
              +
            </Button>
          </HStack>
          <Text
            fontSize="12px"
            color="gray.400"
            fontWeight="600"
            whiteSpace="nowrap"
          >
            Время запроса: {pageStore.request_time.toFixed(2)} сек.
          </Text>
        </HStack>
      </HStack>
    </>
  )
})

export default DateFilters
